import React from 'react';
import pt from 'prop-types';
import {getHelmetForMetaTags} from '../../utils/epicGamesUtils';
import {Page, DelegateLayout, SectionWrapper} from 'epic-ue-components';
import styled from 'styled-components';
import {CenteredEngagementCard} from 'epic-ue-newsletter';
import root from 'window-or-global';
import {getBowserState} from '@epic-core/common';

const Industry = styled.div`
    .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl {
        border: 1px solid #fff;
    }

    .engagement-section {
        margin: 0 auto;
        max-width: 800px;
    }
    .row.email {
        margin-bottom: 15px;
        input {
            height: 40px;
        }
    }
    .card.overlay {
        background-color: rgba(0, 0, 0, 0.35);
        .card-content {
            border-radius: 12px;
        }
    }

    .feature-wrapper .card {
        border-radius: 12px;
        background-color: rgb(35, 35, 35);
    }

    .UEL-sections-wrapper {
        .sections {
            .type-threes {
                width: 33.33%;
                margin: 0;
                height: 475px;
            }
        }
    }

    .sections > section:first-child {
        padding: 50px 0 0;
    }
    .container {
        ${p => p.theme.breakpoints.up('xl')} {
            max-width: 1400px;
            margin-left: auto;
            margin-right: auto;
        }
        .copy-section {
            width: 100%;
        }
        .col-xs-12 {
            width: 100%;
        }

        .row.studyTitle {
            text-align: center;
            h2 {
                margin-left: auto;
                margin-right: auto;
            }
        }

        &.contained {
            .row {
                display: block;
                flex-wrap: initial;
            }
        }
    }

    .row > ul {
        max-width: 85%;
        margin: 0 auto;
        ${p => p.theme.breakpoints.down('sm')} {
            max-width: 100%;
        }
    }

    .header.header-default {
        .container {
            @media (min-width: 1200px) {
                max-width: 1140px !important;
            }
        }
    }

    .header {
        .tag-item {
            background-color: rgb(35, 35, 35, 0.5);
        }
        .tag-item div {
            background-color: transparent;
        }
    }

    .engagement-wrapper.msie {
        > div {
            height: auto;
        }
    }

    .bgMedia-wrap .imageBg {
        background-size: cover;
    }
`;

const ServicesContainer = ({pageData}) => {
    const newsletterData = pageData.newsletterData || {};
    const header = pageData.header || {};
    const buttons = header.buttons || [];
    const {msie} = getBowserState();
    buttons.forEach(button => {
        if (button.className === 'jump-features') {
            button.onClick = e => {
                e.preventDefault();
                const els = root.document.getElementsByClassName('features');
                const firstEl = els[0] || {};
                firstEl.scrollIntoView();
            };
        }
    });

    return (
        <Page>
            <Industry>
                {getHelmetForMetaTags(pageData)}
                <DelegateLayout delegateItems={pageData} />
                <SectionWrapper className={`engagement-wrapper ${msie ? 'msie' : ''}`}>
                    <CenteredEngagementCard newsletterData={newsletterData} disableIndustrySelect marketoLeadParams={{eOSSourceOptIn: true}} epicOptIn />
                </SectionWrapper>
            </Industry>
        </Page>
    );
};

ServicesContainer.propTypes = {
    pageData: pt.object
};

export default ServicesContainer;
